import { render, staticRenderFns } from "./ListBasicInformationsAdditionnelles.vue?vue&type=template&id=0ec1586d&scoped=true&"
import script from "./ListBasicInformationsAdditionnelles.vue?vue&type=script&lang=ts&"
export * from "./ListBasicInformationsAdditionnelles.vue?vue&type=script&lang=ts&"
import style0 from "./ListBasicInformationsAdditionnelles.vue?vue&type=style&index=0&id=0ec1586d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1586d",
  null
  
)

export default component.exports